var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.375,
    cy: 24,
    r: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7052_19503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.657 20.3331C17.874 21.2025 16.4054 22.5713 15.4107 24.2911C15.249 24.5703 15.3447 24.9269 15.6232 25.0881C15.7117 25.1397 15.8124 25.1668 15.9149 25.1667C16.1165 25.1667 16.3125 25.0625 16.4202 24.8756C17.2986 23.3575 18.5951 22.1493 20.1686 21.3813C20.458 21.2401 20.5782 20.8908 20.4369 20.6015C20.2967 20.3121 19.9487 20.1907 19.657 20.3331Z",
    fill: "#DE4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4166 28.6665H36.2205C35.9384 22.7215 31.4099 17.8806 25.6015 17.1169C25.6958 16.9021 25.75 16.6658 25.75 16.4165C25.75 15.4515 24.965 14.6665 24 14.6665C23.035 14.6665 22.25 15.4515 22.25 16.4165C22.25 16.6658 22.3042 16.9021 22.3985 17.1169C16.5901 17.8806 12.0616 22.7215 11.7795 28.6665H10.5834C10.5067 28.6665 10.4309 28.6815 10.3601 28.7108C10.2893 28.7401 10.2249 28.7831 10.1707 28.8373C10.1166 28.8914 10.0736 28.9558 10.0443 29.0266C10.015 29.0974 9.99995 29.1732 10 29.2499V29.8344C10 30.7122 10.2575 31.5627 10.7451 32.2941C10.9579 32.6141 11.2465 32.8764 11.5852 33.0577C11.924 33.239 12.3023 33.3337 12.6865 33.3332H35.3135C35.6978 33.3335 36.0763 33.2388 36.4151 33.0574C36.7539 32.876 37.0426 32.6136 37.2554 32.2936C37.7425 31.5621 38 30.7122 38 29.8344V29.2499C38 29.1732 37.985 29.0974 37.9557 29.0266C37.9264 28.9558 37.8834 28.8914 37.8293 28.8373C37.7751 28.7831 37.7107 28.7401 37.6399 28.7108C37.5691 28.6815 37.4933 28.6665 37.4166 28.6665ZM24 15.8332C24.3218 15.8332 24.5834 16.0947 24.5834 16.4166C24.5834 16.7384 24.3219 16.9999 24 16.9999C23.6781 16.9999 23.4166 16.7384 23.4166 16.4166C23.4166 16.0947 23.6782 15.8332 24 15.8332ZM24 18.1665C29.9145 18.1665 34.7475 22.827 35.0538 28.6665H12.9462C13.2525 22.827 18.0855 18.1665 24 18.1665ZM36.8334 29.8344C36.8339 30.4796 36.6428 31.1105 36.2842 31.647C36.1778 31.8069 36.0334 31.9381 35.8641 32.0287C35.6947 32.1194 35.5056 32.1667 35.3135 32.1666H12.6865C12.4943 32.1667 12.305 32.1194 12.1355 32.0286C11.9661 31.9379 11.8217 31.8066 11.7153 31.6465C11.3571 31.11 11.1662 30.4794 11.1667 29.8344V29.8333H36.8334V29.8344Z",
    fill: "#DE4040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7052_19503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.08c84459e3cbff33524d8a3b6d53a97b.svg";
export { ForwardRef as ReactComponent };